import './TablePaginationActions.scss';
import React from "react";
import {IconButton} from "@mui/material";
import {FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage, Refresh} from "@mui/icons-material";
import {environment} from "../../env";
import type {TablePaginationActionsProps} from '../../utils/mui.types';


export const MithraTablePaginationActions: React.FC<TablePaginationActionsProps> = ({
                                                                                  count,
                                                                                  page,
                                                                                  rowsPerPage,
                                                                                  onPageChange
                                                                              }) => {
    const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return <>
        {environment.isTest &&
            <IconButton onClick={e => onPageChange(e, page)} aria-label="refresh">
                <Refresh/>
            </IconButton>
        }
        <div className="table-pagination-actions">
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                <FirstPage/>
            </IconButton>
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                <KeyboardArrowLeft/>
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                <KeyboardArrowRight/>
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                <LastPage/>
            </IconButton>
        </div>
    </>
}
